import React, { memo } from "react";
import { Grid2 } from "@mui/material";
import { availableViewportHeight } from "./AppLayout";
import { useDebugBorder } from "@core/hooks/useDebugBorder";

interface SplitLayoutProps {
    containerLeft: React.ReactNode;
    containerRight: React.ReactNode;
}

const SplitLayout = memo(({ containerLeft, containerRight }: SplitLayoutProps) => {
    const borderLeft = useDebugBorder("orange");
    const borderRight = useDebugBorder("green");

    return (
        <Grid2 container size={12} spacing={4.5} height={availableViewportHeight} overflow={"hidden"}>
            <Grid2
                minWidth={280}
                maxWidth={"25%"}
                width={320}
                container
                size={12}
                direction={"column"}
                spacing={0.25}
                overflow={"auto"}
                height={`calc(${availableViewportHeight} - 28px)`}
                sx={{ "&::-webkit-scrollbar": { display: "none" }, scrollbarWidth: "none", border: borderLeft }}
            >
                {containerLeft}
            </Grid2>

            <Grid2 container size={"grow"} direction={"column"} height={`calc(${availableViewportHeight} - 28px)`} sx={{ border: borderRight }}>
                <Grid2 container spacing={1} size={"grow"} direction={"column"} overflow={"auto"} sx={{ "&::-webkit-scrollbar": { display: "none" }, scrollbarWidth: "none" }}>
                    {containerRight}
                </Grid2>
            </Grid2>
        </Grid2>
    );
});

export default SplitLayout;
